<template>
  <div class="range-date-picker">
    <date-picker
      v-model="range"
      range
      :lang="lang"
      :not-before="notBefore"
      :not-after="notAfter"
      format="DD.MM.YYYY"
      @change="onChange"
      type="text"
      class="range-date-picker__input"
      placeholder="Укажите период"
    >
    </date-picker>
  </div>
</template>

<script>
// components
import DatePicker from 'vue2-datepicker';

// helpers
import { fromThirtyDays } from '../../../../../helpers/dateHelper.js';

export default {
  name: 'RangeDatePicker',
  data() {
    return {
      range: '',
      // custom lang
      lang: {
        days: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        months: ['Янв', 'Фев', 'Март', 'Апр', 'Май', 'Июнь', 'Июль', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
        placeholder: {
          date: '',
          dateRange: '',
        },
      },
      timePickerOptions: {
        start: '00:00',
        step: '00:30',
        end: '23:30',
      },
      shortcuts: false,
    };
  },
  computed: {
    notBefore() {
      return fromThirtyDays();
    },
    notAfter() {
      return new Date();
    },
  },
  methods: {
    onChange() {
      this.$emit('onChange', this.range);
    },
  },
  components: { DatePicker },
};
</script>

<style>
  .mx-datepicker-range {
    width: 250px;
    margin-right: 10px;
  }
  .mx-input {
    padding: 6px 0 6px 8px;
    width: 100%;
    height: 37px;
    font-family: "Oswald", "Arial", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    letter-spacing: 1px;
    background-color: #eeeeee;
    border-radius: 0;
    border: none;
    outline: none;
    cursor: pointer;
    box-shadow: none;
    box-sizing: border-box;
  }

  .mx-input-append {
    display: none;
  }

  .mx-shortcuts-wrapper {
    display: none;
  }
</style>
